import { TripBoxes } from '../../components/TripBoxes';
import { TripGridSkeleton } from '../../components/skeletons/TripCardSkeleton';
import { TransformedTrip } from '../../hooks/myTrips/useMyTripsData';
import { EmptyTripsState } from './EmptyTripsState';

interface MyTripsGridProps {
  trips?: TransformedTrip[];
  isLoading: boolean;
  hasTrips: boolean;
  onCreateTrip: () => void;
  isCreatingTrip?: boolean;
}

/**
 * Main content area for My Trips page - displays trip grid or empty state.
 */
export const MyTripsGrid = ({
  trips,
  isLoading,
  hasTrips,
  onCreateTrip,
  isCreatingTrip,
}: MyTripsGridProps) => {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-12">
      <div className="rounded-3xl bg-surface p-6 shadow-xl sm:p-10 min-h-[500px]">
        {trips && <TripBoxes trips={trips} />}

        {!trips && isLoading && (
          <div className="mb-16">
            <div className="flex items-center mb-8">
              <TripGridSkeleton />
            </div>
          </div>
        )}

        {!hasTrips && !isLoading && (
          <EmptyTripsState onCreateTrip={onCreateTrip} isCreatingTrip={isCreatingTrip} />
        )}
      </div>
    </div>
  );
};
